/**
 * Which native-menu items belong to a beta feature.
 *
 * The application menu is built in the main process at startup and knows
 * nothing about renderer state, so items owned by a switched-off beta feature
 * are removed by pushing their command ids across (`useAppMenuConfigSync`).
 * Removal rather than disabling is deliberate: a disabled item would keep
 * swallowing its accelerator (`Cmd/Ctrl+I` for Import Data).
 *
 * Only ids that actually appear in `electron/appMenuTemplate.ts` belong here —
 * `appMenuBetaGating.test.ts` pins that.
 */
import { BETA_FEATURE_IDS, resolveBetaFeature, type BetaFeatureId, type BetaFeatureOverrides } from '../../core/beta';

export const BETA_MENU_COMMAND_IDS: Partial<Record<BetaFeatureId, readonly string[]>> = {
  'data-import': ['shell:import-data'],
};

/** Command ids the menu must leave out, given the user's current opt-ins. */
export function hiddenMenuCommandIds(overrides: BetaFeatureOverrides): string[] {
  return BETA_FEATURE_IDS.flatMap((id) =>
    resolveBetaFeature(overrides, id) ? [] : [...(BETA_MENU_COMMAND_IDS[id] ?? [])],
  );
}
